import { delaySecondsToResetRQhook } from "../static/delaySecondsToResetRQhook";

export const closeModalWithDelay = (
  setModalShow: (modalShow: boolean) => void
) => {
  setTimeout(() => {
    setModalShow(false);
  }, delaySecondsToResetRQhook * 1000);
};
